import React, { useState } from 'react';
import { RiskProfile } from '@cloudclevr/components';
import CostBreakdownModal from './CostBreakdownModal';

export interface RoadmapHeaderProps {
  customerName: string;
  roadmapId: string;
  riskProfile: RiskProfile;  
  showCostBreakdown?: boolean;
  preselectedCategoryId?: string;
  onViewAllRecommendations?: () => void;
  onViewCostBreakdown?: () => void;
  onBreadcrumbClick?: () => void;
  className?: string;
  caption?: string;
}

// Risk level color mapping for the ring
const getRiskRingColor = (level: RiskProfile['level']) => {
  const colorMap = {
    Critical: 'border-red-600',
    Moderate: 'border-yellow-500', 
    Low: 'border-[#37afd4]',
    Information: 'border-gray-300'
  };
  return colorMap[level];
};

const RoadmapHeader: React.FC<RoadmapHeaderProps> = ({
  customerName,
  roadmapId,
  riskProfile,
  caption,
  showCostBreakdown,
  preselectedCategoryId
}) => {
    const [isCostBreakdownModalOpen, setIsCostBreakdownModalOpen] = useState(false);

    const handleViewCostBreakdown = () => {
      setIsCostBreakdownModalOpen(true);
    };
  return (
    <div>      
      <div className="flex items-start justify-between">
        {/* Left side - Customer name and risk info */}
        <div className="flex items-center space-x-4">
          {/* Risk Ring - Bigger and Thicker */}
          <div className={`w-14 h-14 rounded-full border-[12px] ${getRiskRingColor(riskProfile.level)} bg-white flex-shrink-0`} />

          {/* Risk Profile and Cost breakdown stacked, vertically centered with the ring */}
          <div className="flex flex-col justify-center space-y-1">
            <div className="flex items-center space-x-3 text-gray-900 font-semibold">
              <span className="text-18">
                <span>Risk profile:</span>{' '}
                <span>{riskProfile.level}</span>
              </span>              
            </div>
            {showCostBreakdown && (          
                <div className="flex items-center space-x-2">            
                  <button
                    onClick={handleViewCostBreakdown}
                    className="text-gray-700 hover:text-gray-900 transition-colors border-0 bg-transparent p-0 text-sm underline underline-offset-4 decoration-[1px] decoration-gray-300"
                  >
                    <span className="text-16">Proposed projects</span>
                  </button>
                </div>
              )}
          </div>
        </div>        
      </div>
      {/* Cost Breakdown Modal */}
      <CostBreakdownModal
        isOpen={isCostBreakdownModalOpen}
        onClose={() => setIsCostBreakdownModalOpen(false)}
        roadmapId={roadmapId}        
        customerName={customerName}
        caption={caption}
        categoryId={preselectedCategoryId}
      /> 
    </div>
  );
};

export default RoadmapHeader;